import Cookies from 'js-cookie';


export const COOKIE_NAME = '_liepaja_settings';

export const getCookieValue = (name, defaultValue) => {
  const settings = getCookieObject();
  if (settings && settings.hasOwnProperty(name)) {
    return settings[name];
  }
  return defaultValue;
}

export const setCookieValue = (name, value) => {
  let settings = getCookieObject();
  settings = Object.assign({}, settings, {
    [name]: value,
  });
  Cookies.set(COOKIE_NAME, settings, { expires: 30 });
}

export const getCookieObject = () => {
  return Cookies.getJSON(COOKIE_NAME);
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js